import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { complianceAlertTriggerService } from '../../../services/complianceAlertTriggerService';

const PngNewsWidget = ({ news }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Subscribe to real-time news updates and automatically trigger compliance alerts
    const channel = complianceAlertTriggerService?.subscribeToNewsUpdates((newNews, alerts) => {
      console.log('Compliance alerts triggered:', alerts);
      // Alerts are automatically created in the system
    });

    return () => {
      complianceAlertTriggerService?.unsubscribeFromNewsUpdates(channel);
    };
  }, []);

  const getCategoryColor = (category) => {
    const colors = {
      hr: 'var(--color-info)',
      payroll: 'var(--color-success)',
      tax: 'var(--color-warning)',
      minimum_wage: 'var(--color-error)',
      employment_act: 'var(--color-primary)',
      gazette: 'var(--color-accent)',
      general: 'var(--color-muted-foreground)'
    };
    return colors?.[category] || 'var(--color-muted-foreground)';
  };

  const getCategoryLabel = (category) => {
    const labels = {
      hr: 'HR',
      payroll: 'Payroll',
      tax: 'Tax',
      minimum_wage: 'Min Wage',
      employment_act: 'Employment Act',
      gazette: 'Gazette',
      general: 'General'
    };
    return labels?.[category] || category;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-PG', {
      day: '2-digit',
      month: 'short'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 w-full overflow-hidden">
      <div className="flex items-center justify-between mb-4 gap-2">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <Icon name="Newspaper" size={20} color="var(--color-primary)" className="flex-shrink-0" />
          <h3 className="font-heading font-semibold text-base text-foreground truncate">
            PNG Government News
          </h3>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={() => navigate('/png-news-updates')}
          className="flex-shrink-0"
        >
          <span className="hidden sm:inline">View All</span>
          <span className="sm:hidden">All</span>
        </Button>
      </div>

      {news?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Newspaper" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">No recent news updates</p>
        </div>
      ) : (
        <div className="space-y-3">
          {news?.map((item) => (
            <div
              key={item?.id}
              className="p-3 bg-muted/50 rounded-md hover:bg-muted transition-smooth cursor-pointer"
              onClick={() => navigate('/png-news-updates')}
            >
              <div className="flex items-start justify-between gap-2 mb-2">
                <div
                  className="px-2 py-0.5 rounded text-xs font-medium flex-shrink-0"
                  style={{ backgroundColor: `${getCategoryColor(item?.category)}15`, color: getCategoryColor(item?.category) }}
                >
                  {getCategoryLabel(item?.category)}
                </div>
                <span className="text-xs text-muted-foreground whitespace-nowrap">
                  {formatDate(item?.publicationDate)}
                </span>
              </div>
              <h4 className="text-sm font-medium text-foreground mb-1 line-clamp-2 break-words">
                {item?.title}
              </h4>
              <p className="text-xs text-muted-foreground line-clamp-2">
                {item?.summary}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PngNewsWidget;